module.exports = __webpack_public_path__ + "static/REQUISITIDIPARTECIPAZIONE-2ee14b7232cbfdf7b7ad35a72d983dd3.pdf";